import React from 'react';

import * as S from './styles';

function Star() {
  return <S.Tistar />;
}

export default Star;